import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { waGeneral } from "@/lib/whatsapp";

const WhatsAppFloat = () => (
  <motion.a
    href={waGeneral()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Falar com a DM Imports no WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="animate-wa-pulse fixed bottom-6 right-6 z-[70] flex h-14 w-14 items-center justify-center rounded-full bg-wa text-obsidian shadow-2xl sm:bottom-8 sm:right-8"
  >
    <MessageCircle className="h-6 w-6" fill="currentColor" />
  </motion.a>
);

export default WhatsAppFloat;
